/* eslint-disable import/prefer-default-export */
export const SET_SHOWN_PROPERTIES = 'SET_SHOWN_PROPERTIES';
